export default function ReloadIcon() {
  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5111 8.76775H13.5111M13.5111 8.76775V11.7678M13.5111 8.76775L11.3898 10.8891C10.879 11.3998 10.2727 11.8049 9.60543 12.0813C8.93814 12.3577 8.22294 12.5 7.50067 12.5C6.7784 12.5 6.0632 12.3577 5.39591 12.0813C4.72862 11.8049 4.12231 11.3998 3.61158 10.8891M4.49023 5.23225H1.49023M1.49023 5.23225V2.23225M1.49023 5.23225L3.61158 3.11091C4.12231 2.60019 4.72862 2.19506 5.39591 1.91866C6.0632 1.64226 6.7784 1.5 7.50067 1.5C8.22294 1.5 8.93814 1.64226 9.60543 1.91866C10.2727 2.19506 10.879 2.60019 11.3898 3.11091"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
